export const TRACKER_STORAGE_KEYS = {
  sendFormInitiatedAt: 'digital-forms-send-form-initiated-at',
  myFormsVisitedAt: 'digital-forms-my-forms-visited-at',
};

export const PRESET_STORAGE_VALUES = {
  sendForm: {
    trackingComplete: 'tracked',
  },
};

export const PENDO_TRACKING_KEYS = {
  sendForm: 'send-digital-form',
  myForms: 'my-forms-visit',
};
